import routes from "@/routes/routes.json"
import { IsDBLURL } from "./location";
import { clearUser } from "./analytics";
export const forceLogout = () => {
  clearUser();
  sessionStorage.clear();
  sessionStorage.removeItem("bearer_token");
  if(!IsDBLURL()){
    window.location.href = routes.dashboard;
    // sessionStorage.removeItem("bearer_token_dbl");
  }else{
    window.location.reload()
  }

};
